<template>
	<o-tour :ref="setup._tourOrderDetailsAgency">
		<o-tour-step
			:title="$t('business.order.apiErrors.tour.orderDetails')"
			size="lg"
			hide-finish>
			<template #actions="{ next }">
				<o-button
					size="xs"
					outline
					color="info"
					@click="setup.openDiscussion()">
					{{ $t('common.order.orderDetails.contactClient') }}
				</o-button>
				<o-button
					size="xs"
					color="brand"
					@click="next">
					{{ $t('common.actions.validate') }}
				</o-button>
			</template>
			<p v-html="$t('common.order.orderDetails.description')"/>
			<o-alert color="info">
				{{ $t('common.order.orderDetails.tip') }}
			</o-alert>
			<ul>
				<li v-html="$t('common.order.orderDetails.candidateTracking')"/>
				<li v-html="$t('common.order.orderDetails.orderLifecycle')"/>
				<li v-html="$t('common.order.orderDetails.summary')"/>
				<li v-html="$t('common.order.orderDetails.history')"/>
			</ul>
			<o-alert color="info">
				<div v-html="$t('common.order.orderDetails.modificationWarning')"/>
			</o-alert>
		</o-tour-step>

		<o-tour-step
			:title="$t('business.order.apiErrors.tour.summaryGoBack')"
			target="order-details__back"
			hide-finish>
			Cliquez ici si vous souhaitez <b>{{ $t('business.goBack') }}</b>{{ $t('business.andFind') }}<b>{{ $t('business.theList') }}</b> des commandes !
		</o-tour-step>

		<o-tour-step
			:title="$t('business.order.apiErrors.tour.discussWithContact')"
			target="order-details__discussion"
			:hide-finish="setup.canUpdate">
			<template #actions="{ next, previous }">
				<o-button
					size="xs"
					outline
					color="info"
					@click="setup.openDiscussion()">
					{{ $t('common.order.orderDetails.contactClient') }}
				</o-button>
				<o-button
					size="xs"
					outline
					@click="previous">
					{{ $t('common.actions.cancel') }}
				</o-button>
				<o-button
					v-if="setup.canUpdate"
					size="xs"
					color="brand"
					@click="next">
					{{ $t('common.actions.validate') }}
				</o-button>
			</template>
			<span v-html="$t('common.order.orderDetails.discussionInfo')"/>
		</o-tour-step>

		<o-tour-step
			v-if="setup.canCancel"
			size="lg"
			:title="$t('business.order.apiErrors.tour.cancelOrder')"
			target="order-details__cancel"
			hide-finish>
			<p v-html="$t('common.order.orderDetails.cancelDescription')"/>

			<o-alert color="info">
				<div v-html="$t('common.order.orderDetails.cancelAlert')"/>
			</o-alert>
		</o-tour-step>

		<o-tour-step
			v-if="setup.canUpdate"
			size="lg"
			:title="$t('business.order.apiErrors.tour.duplicateOrder')"
			target="order-details__copy"
			:hide-finish="setup.canValidate">
			<p v-html="$t('common.order.orderDetails.duplicateIntro')"/>

			<p v-html="$t('common.order.orderDetails.duplicateProcess')"/>

			<span v-html="$t('common.order.orderDetails.duplicateCandidates')"/>
		</o-tour-step>

		<o-tour-step
			v-if="setup.canValidate"
			size="lg"
			:title="$t('business.order.apiErrors.tour.validateOrder')"
			target="order-details__validate">
			<p v-html="$t('common.order.orderDetails.validateIntro')"/>

			<p v-html="$t('common.order.orderDetails.validateEffect')"/>

			<o-alert color="info">
				<div v-html="$t('common.order.orderDetails.validateAlert')"/>
			</o-alert>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
// #region Setup
import type { TourOrderDetailsAgencyEmits, TourOrderDetailsAgencyProps } from './TourOrderDetailsAgencySetup';
import TourOrderDetailsAgencySetup from './TourOrderDetailsAgencySetup';
const emits = defineEmits<TourOrderDetailsAgencyEmits>() as TourOrderDetailsAgencyEmits;
const props = withDefaults(defineProps<TourOrderDetailsAgencyProps>(), TourOrderDetailsAgencySetup.defaultProps);
const setup = new TourOrderDetailsAgencySetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
.tour-link {
	cursor: pointer;
	font-weight: bold;
	color: var(--info);
}
</style>
